<template>
    <v-menu v-model="menu" :close-on-content-click="false" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-select
            v-bind="attrs"
            v-on="on"
            v-model="selectedAnimals"
            :items="selectedAnimals"
            outlined
            dense
            chips
            small-chips
            multiple
            hide-no-data
            readonly
            @click="openMenu"
            @click:append="menu = true"
        >
            <template v-slot:selection="data">
                <v-chip
                  small
                  >
                  <!-- @click:close="remove(data.item)" -->
                  {{ data.item.animalNumber }}
                </v-chip>
            </template>
        </v-select>
        <!-- <v-text-field
          v-bind="attrs"
          v-on="on"
          type="text"
          v-model="selectedAnimals"
          :placeholder="$t('Select animals')"
          outlined
          dense
          chips
          readonly
          :loading="loading"
          append-icon="mdi-menu-down"
          @click="menu = true"
          @click:append="menu = true"
        ></v-text-field> -->
      </template>
      <v-card>
        <v-toolbar flat class="pt-5 pb-0">
          <v-text-field
            type="text"
            :placeholder="'Search Animal'"
            outlined
            dense
            v-model="search"
            @input="getAnimalsWithSearch"
            class="mr-5"
          ></v-text-field>
          <v-spacer></v-spacer>
          <div class="mt-n5">
            <v-btn fab outlined x-small depressed color="primary" @click="page=page-1" :disabled="page==1"><v-icon>mdi-chevron-left</v-icon></v-btn>
            <v-btn fab outlined x-small depressed color="primary" @click="page=page+1" class="mx-2" :disabled="page==totalPages"><v-icon>mdi-chevron-right</v-icon></v-btn>
          </div>
        </v-toolbar>
        <v-card-text class="pt-0">
          <div class="text-center" v-if="this.loading">
            <v-progress-circular
                :size="100"
                color="primary"
                indeterminate
                style="margin:auto"
                
            ></v-progress-circular>
          </div>
              
          <v-list-item-group v-else class="px-0" v-model="selectedAnimals" multiple>
            <v-list flat style="max-height: 250px" class="overflow-y-auto">
                <v-list-item
                    v-for="animal in animalList"
                    :key="animal.animalNumber"
                    :color="animal == value ? 'primary' : ''"
                    :value="animal"
                >
                <template v-slot:default="{  }">
                        <v-list-item-action>
                            <v-checkbox :ripple="false" :input-value="showSelected(animal)"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{
                            `${animal.animalNumber} (${animal.gender || "N/A"})`
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </template>
                </v-list-item>
            </v-list>
          </v-list-item-group>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" depressed @click="menu=false">CLOSE</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-menu>
  </template>
  <script>
  import AnimalService from "@/_services/AnimalService";
  
  export default {
    mounted() {
        this.getAnimals()
    },
    props: {
      value: {
        required: false,
      },
      animalType: {
        type: String,
        required: true,
      },
      source: {
        type: String,
      },
      currentAnimal: {
        type: String,
      },
      farms: {
        type: Array,
        required: true
      },
    },
    watch: {
        selectedAnimals: {
            handler() {
                this.$emit("input", this.selectedAnimals);
            }
        },
        animalType: {
            handler() {
                this.page = 1;
                this.getAnimals()
            }
        },
        value: {
            handler(val) {
                console.log('val',val)
                this.selectedAnimals = val;
            },
            deep: true,
            immediate: true
        },
        page: {
            handler() {
                this.getAnimals()
            }
        },
        farms: {
            handler() {
                this.getAnimals()
                this.filterSelectedAnimals()
            },
            deep: true,
            immediate: true
        }
    },
    data() {
      return {
        onlyExisting: false,
        menu: false,
        selectedAnimals: [],
        search: "",
        animalList: [],
        inputField: "",
        loading: false,
        page: 1,
        limit: 20,
        totalPages: 1,
        totalRecords: 0,
      };
    },
  
    methods: {
      showSelected(current) {
            const find = this.selectedAnimals.filter(ani => ani.animalNumber == current.animalNumber)
            if(find.length)
                return true
            else
                return false
        },
        testfunciton(prm) {
            console.log('prm', prm)
        },
        // remove (item) {
        //     const index = this.selectedAnimals.indexOf(item)
        //     if (index >= 0) this.selectedAnimals.splice(index, 1)
        // },
        openMenu() {
            // console.log('sldjfksl')
            this.menu = true
        },
        getAnimalText(item) {
            return `${item.animalNumber} (${item?.gender || this.gender})`
        },
      getAnimalsWithSearch() {
        this.page = 1;
        this.getAnimals()
      },
      getAnimals() {
        this.loading = true;
        if(this.source&&this.source=='lgcloud'){
          AnimalService.getAnimals(
          this.animalType,
          {
              page: this.page,
              itemsPerPage: this.limit,
          },
          this.search,
          "lgcloud"
        )
          .then(res => {
            this.animalList = res.data.rows;
            this.totalRecords =  res.data.totalRows;
            this.totalPages = Math.ceil(Number(res.data.totalRows) / this.limit)
            this.loading = false;
          })
          .catch(e => {
            console.log("error", e);
            this.loading = false;
          });
        }
        // else if(this.animalType == 'All'){
        //   AnimalService.getAnimals(
        //   this.animalType,
        //   {
        //       page: this.page,
        //       itemsPerPage: this.limit,
        //   },
        //   this.search,
        //   "lgcomm"
        // )
        //   .then(res => {
        //     this.animalList = res.data.rows;
        //     this.totalRecords =  res.data.totalRows;
        //     this.totalPages = Math.ceil(Number(res.data.totalRows) / this.limit)
        //     this.loading = false;
        //   })
        //   .catch(e => {
        //     console.log("error", e);
        //     this.loading = false;
        //   });
        // } 
        else{
          AnimalService.getAnimalWithGender(
          this.animalType.toLowerCase(),
          {
              page: this.page,
              itemsPerPage: this.limit,
          },
          this.search,
          this.currentAnimal,
          this.farms
        )
          .then(res => res.data)
          // .then(data => data.animalList)
          .then(data => {
            this.animalList = data.animalList;
            this.totalRecords =  data.totalRecords;
            this.totalPages = Math.ceil(Number(data.totalRecords) / this.limit)
            this.loading = false;
          })
          .catch(e => {
            console.log("error", e);
            this.loading = false;
          });
        }
      },
  
      imageUrl(animal) {
        return animal?.img?.url || "/img/no_img.png";
      },
      filterSelectedAnimals() {
        if(this.selectedAnimals.length) {
            let filtered = this.selectedAnimals.filter( ({animalFarmNo}) => this.farms.includes(animalFarmNo))
            this.selectedAnimals = filtered;
        }
      }

    },
  };
  </script>
  